import { testimonials } from '@/mocks/testimonials';

export default function TestimonialGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-[1280px] mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 mb-3">
              <span className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
                <i className="ri-shield-check-line text-accent-500"></i>
              </span>
              <span className="text-xs font-semibold uppercase tracking-widest text-foreground-400">
                Trusted by Users
              </span>
            </div>
            <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold text-foreground-950 tracking-tight">
              What Buyers Say
            </h2>
            <p className="mt-3 text-foreground-500 text-sm max-w-md mx-auto">
              Real feedback from <strong>pandabuyspreadsheet</strong> users worldwide
            </p>
          </div>

          {/* Testimonial Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {/* Card 1 */}
            <div className="bg-background-50 rounded-2xl p-6 md:p-7">
              <div className="flex items-center gap-3 mb-5">
                <img
                  src={testimonials[0].avatarUrl}
                  alt={testimonials[0].name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{testimonials[0].name}</p>
                  <p className="text-xs text-foreground-500">{testimonials[0].role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-2xl text-accent-300 mb-3 block"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{testimonials[0].text}</p>
            </div>

            {/* Card 2 */}
            <div className="bg-background-50 rounded-2xl p-6 md:p-7">
              <div className="flex items-center gap-3 mb-5">
                <img
                  src={testimonials[1].avatarUrl}
                  alt={testimonials[1].name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{testimonials[1].name}</p>
                  <p className="text-xs text-foreground-500">{testimonials[1].role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-2xl text-accent-300 mb-3 block"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{testimonials[1].text}</p>
            </div>

            {/* Card 3 - Image background */}
            <div className="relative rounded-2xl overflow-hidden min-h-[280px]">
              <img
                src="https://readdy.ai/api/search-image?query=Happy%20young%20professional%20unboxing%20curated%20fashion%20items%20at%20a%20warm%20minimalist%20desk%20with%20genuine%20smile%2C%20soft%20natural%20side%20lighting%2C%20lifestyle%20photography%20with%20cream%20and%20beige%20palette%2C%20authentic%20editorial%20composition&width=600&height=700&seq=testimonial-img-v2&orientation=portrait"
                alt="Satisfied pandabuy spreadsheet user unboxing"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-black/70 to-transparent">
                <p className="text-background-50 text-sm font-semibold">{testimonials[3].name}</p>
                <p className="text-background-50/70 text-xs">{testimonials[3].role}</p>
              </div>
            </div>

            {/* Card 4 - Wide */}
            <div className="md:col-span-2 relative rounded-2xl overflow-hidden min-h-[240px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20wide%20shot%20of%20modern%20home%20office%20with%20laptop%20showing%20spreadsheet%20data%20and%20organized%20product%20samples%20nearby%2C%20soft%20morning%20light%20streaming%20in%2C%20editorial%20lifestyle%20photography%20with%20beige%20and%20cream%20palette%2C%20clean%20cozy%20composition&width=1200&height=500&seq=testimonial-wide-v2&orientation=landscape"
                alt="Professional pandabuy spreadsheet workspace setup"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/70 via-black/40 to-transparent">
                <div className="flex items-center gap-3 mb-2">
                  <img
                    src={testimonials[4].avatarUrl}
                    alt={testimonials[4].name}
                    className="w-9 h-9 rounded-full object-cover border border-background-50/30"
                  />
                  <div>
                    <p className="text-background-50 text-sm font-semibold">{testimonials[4].name}</p>
                    <p className="text-background-50/70 text-xs">{testimonials[4].role}</p>
                  </div>
                </div>
                <p className="text-background-50/90 text-sm leading-relaxed">{testimonials[4].text}</p>
              </div>
            </div>

            {/* Card 5 */}
            <div className="bg-background-50 rounded-2xl p-6 md:p-7">
              <div className="flex items-center gap-3 mb-5">
                <img
                  src={testimonials[2].avatarUrl}
                  alt={testimonials[2].name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{testimonials[2].name}</p>
                  <p className="text-xs text-foreground-500">{testimonials[2].role}</p>
                </div>
              </div>
              <i className="ri-double-quotes-l text-2xl text-accent-300 mb-3 block"></i>
              <p className="text-sm text-foreground-700 leading-relaxed">{testimonials[2].text}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}